<template>
  <div class="info-tool-tip">
    <base-tool-tip :icon-path="'icon-info.svg'">
      <div class="info-text">
        <div>
          <span class="text">{{ text }}</span>
          <span class="popup-text" v-on:click="openPopup">{{ popupText }}</span>
        </div>
      </div>
    </base-tool-tip>
  </div>
</template>

<script>
import BaseToolTip from './BaseToolTip.vue';
import ModalBus from '../../event-bus/modal-bus';
import Segment from '../../Segment';

export default {
  name: 'InfoToolTip',
  props: {
    text: {
      type: String,
    },
    popupText: {
      type: String,
    },
    eventName: {
      type: String,
    },
    popupComponent: {
      type: Object,
    },
    popupProps: {
      type: Object,
    },
  },
  components: {
    BaseToolTip,
  },
  methods: {
    openPopup() {
      if (this.eventName) {
        Segment.trackUserInteraction(this.eventName);
      }
      ModalBus.$emit('open', {
        component: this.popupComponent,
        props: this.popupProps,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .info-tool-tip {
    width: 100%;

    .info-text {
      display: flex;
      align-items: center;
      font-family: SimplerPro;
      font-size: 14px;
      line-height: 1.36;
      height: 100%;

      .text{
      }

      .popup-text{
        font-weight: bold;
        color: $riseup_blue;
        cursor: pointer;
      }
    }
  }
</style>
